<template>
  <JobColumn :job-title="jobTitle" :job-id="hireNumber" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import JobColumn from '@/components/GraphqlDataTable/columns/JobColumn.vue'
import { useTranslation } from '@/composables/translation'

const PaymentRequestJobColumn = graphql(`
  fragment PaymentRequestJobColumn on PaymentRequest {
    id
    hire {
      number
      activeContract {
        id
        jobName
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestJobColumn>
}>()

const { $t } = useTranslation()

const column = computed(() => useFragment(PaymentRequestJobColumn, props.row))

const jobTitle = computed(() => column.value.hire?.activeContract?.jobName || $t('No job assigned'))

const hireNumber = computed(() =>
  column.value.hire?.number ? `#${column.value.hire?.number}` : '--',
)
</script>

<style scoped></style>
